import { render, staticRenderFns } from "./addadministrator.vue?vue&type=template&id=393152bc&scoped=true&"
import script from "./addadministrator.vue?vue&type=script&lang=js&"
export * from "./addadministrator.vue?vue&type=script&lang=js&"
import style0 from "./addadministrator.vue?vue&type=style&index=0&id=393152bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393152bc",
  null
  
)

export default component.exports